import { Injectable } from '@angular/core';
import { Storage } from '@capacitor/storage';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  data: any;
  tmp: any = {};
  public isLoaded = false;
  private STORE_KEY = 'samea-bao';
  private _caches: Map<string, {data: any; expiry: Date}> = new Map();
  constructor() {
  }

  async logout() {
    await this.merge({
      token: null,
      msisdn: null,
      logged: false
    });
    try {
      await this.clear();
      this._caches.clear();
      this.data = {};
      console.log('LLLLDLLDLDLDLLDLDLLDLD');
      window.location.href = '/welcome';
    } catch (error) {
      console.log('Error::::', error);
    }
  }

  async load() {
    if (this.data) {
      return this.data;
    }
    this.tmp.isLoaded = true;
    const { value } = await Storage.get({ key: this.STORE_KEY });
    if (value) {
      this.data = JSON.parse(value);
      return this.data;
    } else {
      this.data = {};
      return await this.setAll(this.data);
    }
  }

  async merge(data: any) {
    for (const k of Object.keys(data)) {
      this.data[k] = data[k];
    }
    return await this.save();
  }

  async setValue(key: string, value: any) {
    this.data[key] = value;
    await Storage.set({ key: this.STORE_KEY, value: JSON.stringify(this.data) });
    return this.data;
  }
  async removeValue(key: string) {
    delete this.data[key];
    await Storage.set({ key: this.STORE_KEY, value: JSON.stringify(this.data) });
    return this.data;
  }

  async setAll(value: any) {
    return await Storage.set({ key: this.STORE_KEY, value: JSON.stringify(value) });
  }

  async getValue(key: string) {
    const { value: settings } = await Storage.get({ key: this.STORE_KEY });
    if (!settings) {
      return null;
    }
    return JSON.parse(settings)[key];
  }

  clear() {
    return Storage.clear();
  }

  save() {
    return this.setAll(this.data);
  }
  /**
   *
   */
  get allSettings() {
    return this.data;
  }

  setAdvancedData(key: string, value: any) {
    const nestedKeys = key.split('.');
    const lastToken = nestedKeys[nestedKeys.length - 1];
    let next = null;
    for (const k of nestedKeys.slice(0, nestedKeys.length - 1)) {
      if (!next) {
        next = this.data[k] = this.data[k] || {};
        continue;
      }
      if (!next[k]) {
        next[k] = {};
      }
      next = next[k];
    }
    if (!next) {
      next = this.data[lastToken];
    }
    next[lastToken] = value;
    return this.save();
  }
  getAdvancedData(key: string) {
    const nestedKeys = key.split('.');
    console.log('nestedKeys', nestedKeys);
    const lastToken = nestedKeys[nestedKeys.length - 1];
    console.log('lastToken', lastToken);
    const remains = nestedKeys.slice(0, nestedKeys.length - 1);
    console.log('lastToken', remains);
    let next = null;
    for (const k of remains) {
      if (!next) {
        next = this.data[k] = this.data[k] || {};
        continue;
      }
      if (!next[k]) {
        next[k] = {};
      }
      next = next[k];
    }
    if (!next) {
      next = this.data[lastToken];
    }
    return Promise.resolve(next[lastToken]);
  }

  setPersistedData(key: string, value: any) {
    return Storage.set({ key, value: JSON.stringify(value) });
  }
  async getPersistedData(key: string) {
    const { value } = await Storage.get({ key });
    return value  && JSON.parse(value);
  }

  fromCache(key: string) {
    const data = this._caches.get(key);
    if (!data || new Date().getTime() > data.expiry.getTime()) {
      return null;
    }
    return data.data;
  }
  cache(key: string, data: any, ttl = 100_000) {
    this._caches.set(key, {
      data,
      expiry: new Date(new Date().getTime() + ttl)
    });
  }
  invalidateCache(key: string) {
    this._caches.delete(key);
  }
}
